import { DateRange } from "components/Graphs/DateRangePicker";

export const timeRanges = [
  { label: "Last 1 hour", value: "1h", hours: 1 },
  { label: "Last 4 hours", value: "4h", hours: 4 },
  { label: "Last 6 hours", value: "6h", hours: 6 },
  { label: "Last 12 hours", value: "12h", hours: 12 },
  { label: "Last day", value: "1d", hours: 24 },
  { label: "Last 2 days", value: "2d", hours: 48 },
  { label: "Last 7 days", value: "7d", hours: 168 },
  { label: "Last 30 days", value: "30d", hours: 720 },
] as const;

export type TimeRangeValue = (typeof timeRanges)[number]["value"];

export const getDateRangeForTimeRange = (value: TimeRangeValue): DateRange => {
  const now = new Date();
  const range = timeRanges.find((r) => r.value === value);
  if (!range) return { from: now, to: now };

  const from = new Date(now);
  from.setHours(from.getHours() - range.hours);

  return { from, to: now };
};

export const getTimeRangeLabel = (dateRange: DateRange): string => {
  const { from, to } = dateRange;
  if (!from || !to) return "Select time range";

  const diffHours = (to.getTime() - from.getTime()) / (1000 * 60 * 60);

  // Find the closest matching time range
  const matchingRange = timeRanges.find((range) => diffHours <= range.hours);
  return matchingRange?.label || "Custom range";
};
